<template>
  <b-container>
    <!-- DisplayName -->
    <b-form-group label-for="DisplayName" :label="$t('geral.displayName')">
      <b-form-input
        id="DisplayName"
        type="text"
        placeholder="Informe o nome de exibição"
        v-model="model.displayName"
      />
      <span class="text-danger" v-if="modelstate['DisplayName']">
        {{ modelstate["DisplayName"][0] }}
      </span>
    </b-form-group>

    <!-- Administrator -->
    <b-form-group
      label-for="Administrator"
      :label="$t('profile.administrator')"
    >
      <b-form-select
        id="Administrator"
        :options="optionsBoolean"
        v-model="model.administrator"
      />
      <span class="text-danger" v-if="modelstate['Administrator']">
        {{ modelstate["Administrator"][0] }}
      </span>
    </b-form-group>

    <h3>Liberações Gerais</h3>

    <!-- AccessCompany -->
    <!-- <b-form-group
      label-for="AccessCompany"
      :label="$t('profile.accessCompany')"
    >
      <b-form-select
        id="accessCompany"
        :options="optionsBoolean"
        v-model="model.accessCompany"
      />
      <span class="text-danger" v-if="modelstate['AccessCompany']">
        {{ modelstate["AccessCompany"][0] }}
      </span>
    </b-form-group> -->

    <!-- AccessUser -->
    <b-form-group label-for="AccessUser" :label="$t('profile.accessUser')">
      <b-form-select
        id="accessUser"
        :options="optionsBoolean"
        v-model="model.accessUser"
      />
      <span class="text-danger" v-if="modelstate['AccessUser']">
        {{ modelstate["AccessUser"][0] }}
      </span>
    </b-form-group>

    <!-- CanImportUser -->
    <b-form-group
      label-for="CanImportUser"
      :label="$t('profile.canImportUser')"
    >
      <b-form-select
        id="canImportUser"
        :options="optionsBoolean"
        v-model="model.canImportUser"
      />
      <span class="text-danger" v-if="modelstate['CanImportUser']">
        {{ modelstate["CanImportUser"][0] }}
      </span>
    </b-form-group>

    <!-- AccessProfile -->
    <b-form-group
      label-for="AccessProfile"
      :label="$t('profile.accessProfile')"
    >
      <b-form-select
        id="accessProfile"
        :options="optionsBoolean"
        v-model="model.accessProfile"
      />
      <span class="text-danger" v-if="modelstate['AccessProfile']">
        {{ modelstate["AccessProfile"][0] }}
      </span>
    </b-form-group>

    <!-- AccessVehicles -->
    <b-form-group
      label-for="AccessVehicles"
      :label="$t('profile.accessVehicles')"
    >
      <b-form-select
        id="lookVehicles"
        :options="optionsBoolean"
        v-model="model.accessVehicles"
      />
      <span class="text-danger" v-if="modelstate['AccessVehicles']">
        {{ modelstate["AccessVehicles"][0] }}
      </span>
    </b-form-group>

    <!-- AccessTripPlan -->
    <b-form-group
      label-for="AccessTripPlan"
      :label="$t('profile.accessTripPlan')"
    >
      <b-form-select
        id="accessTripPlan"
        :options="optionsBoolean"
        v-model="model.accessTripPlan"
      />
      <span class="text-danger" v-if="modelstate['AccessTripPlan']">
        {{ modelstate["AccessTripPlan"][0] }}
      </span>
    </b-form-group>

    <div v-if="hasReleaseChecklist" class="mt-4">
      <h3>Liberações Checklist</h3>

      <!-- CheckelistTypingForm -->
      <b-form-group
        label-for="CheckelistTypingForm"
        :label="$t('profile.checkelistTypingForm')"
      >
        <b-form-select
          id="CheckelistTypingForm"
          :options="optionsBoolean"
          v-model="model.checkelistTypingForm"
        />
        <span class="text-danger" v-if="modelstate['CheckelistTypingForm']">
          {{ modelstate["CheckelistTypingForm"][0] }}
        </span>
      </b-form-group>

      <!-- ChecklistFormCreator -->
      <b-form-group
        label-for="ChecklistFormCreator"
        :label="$t('profile.criadorFormularios')"
      >
        <b-form-select
          id="ChecklistFormCreator"
          :options="optionsBoolean"
          v-model="model.checklistFormCreator"
        />
        <span class="text-danger" v-if="modelstate['ChecklistFormCreator']">
          {{ modelstate["ChecklistFormCreator"][0] }}
        </span>
      </b-form-group>

      <!-- CanEditForm -->
      <b-form-group label-for="CanEditForm" :label="$t('profile.canEditForm')">
        <b-form-select
          id="CanEditForm"
          :options="optionsBoolean"
          v-model="model.canEditForm"
        />
        <span class="text-danger" v-if="modelstate['CanEditForm']">
          {{ modelstate["CanEditForm"][0] }}
        </span>
      </b-form-group>

      <!-- CanDeleteForm -->
      <b-form-group
        label-for="CanDeleteForm"
        :label="$t('profile.canDeleteForm')"
      >
        <b-form-select
          id="CanDeleteForm"
          :options="optionsBoolean"
          v-model="model.canDeleteForm"
        />
        <span class="text-danger" v-if="modelstate['CanDeleteForm']">
          {{ modelstate["CanDeleteForm"][0] }}
        </span>
      </b-form-group>

      <!-- CanReopenForm -->
      <b-form-group
        label-for="CanReopenForm"
        :label="$t('profile.canReopenForm')"
      >
        <b-form-select
          id="CanReopenForm"
          :options="optionsBoolean"
          v-model="model.canReopenForm"
        />
        <span class="text-danger" v-if="modelstate['CanReopenForm']">
          {{ modelstate["CanReopenForm"][0] }}
        </span>
      </b-form-group>

      <!-- ChecklistPendenciesView -->
      <b-form-group
        label-for="ChecklistPendenciesView"
        :label="$t('profile.checklistPendenciesView')"
      >
        <b-form-select
          id="ChecklistPendenciesView"
          :options="optionsBoolean"
          v-model="model.checklistPendenciesView"
        />
        <span class="text-danger" v-if="modelstate['ChecklistPendenciesView']">
          {{ modelstate["ChecklistPendenciesView"][0] }}
        </span>
      </b-form-group>

      <!-- CanAccessJustOwnChecklists -->
      <b-form-group
        label-for="CanAccessJustOwnChecklists"
        :label="$t('profile.accessJustOwnChecklists')"
      >
        <b-form-select
          id="AccessJustOwnChecklists"
          :options="optionsBoolean"
          v-model="model.canAccessJustOwnChecklist"
        />
        <span
          class="text-danger"
          v-if="modelstate['CanAccessJustOwnChecklists']"
        >
          {{ modelstate["CanAccessJustOwnChecklists"][0] }}
        </span>
      </b-form-group>
    </div>

    <div v-if="$store.getters.hasAccessFuelSupply" class="mt-4">
      <h3>{{ $t("profile.accessFuelSupplyPermissions") }}</h3>

      <!-- AccessFuelSupply -->
      <b-form-group
        label-for="AccessFuelSupply"
        :label="$t('profile.accessFuelSupply')"
      >
        <b-form-select
          id="AccessFuelSupply"
          :options="optionsBoolean"
          v-model="model.accessFuelSupply"
        />
        <span class="text-danger" v-if="modelstate['AccessFuelSupply']">
          {{ modelstate["AccessFuelSupply"][0] }}
        </span>
      </b-form-group>

      <!-- AccessFuelSupplyJustOwn -->
      <b-form-group
        label-for="AccessFuelSupplyJustOwn"
        :label="$t('profile.accessFuelSupplyJustOwn')"
      >
        <b-form-select
          id="AccessFuelSupplyJustOwn"
          :options="optionsBoolean"
          v-model="model.accessFuelSupplyJustOwn"
        />
        <span class="text-danger" v-if="modelstate['AccessFuelSupplyJustOwn']">
          {{ modelstate["AccessFuelSupplyJustOwn"][0] }}
        </span>
      </b-form-group>

      <!-- AccessFuelSupplyDashboard -->
      <b-form-group
        label-for="AccessFuelSupplyDashboard"
        :label="$t('profile.accessFuelSupplyDashboard')"
      >
        <b-form-select
          id="AccessFuelSupplyDashboard"
          :options="optionsBoolean"
          v-model="model.accessFuelSupplyDashboard"
        />
        <span
          class="text-danger"
          v-if="modelstate['AccessFuelSupplyDashboard']"
        >
          {{ modelstate["AccessFuelSupplyDashboard"][0] }}
        </span>
      </b-form-group>

      <!-- AccessFuelConsumptionTarget -->
      <b-form-group
        label-for="AccessFuelConsumptionTarget"
        :label="$t('profile.accessFuelConsumptionTarget')"
      >
        <b-form-select
          id="AccessFuelConsumptionTarget"
          :options="optionsBoolean"
          v-model="model.accessFuelConsumptionTarget"
        />
        <span
          class="text-danger"
          v-if="modelstate['AccessFuelConsumptionTarget']"
        >
          {{ modelstate["AccessFuelConsumptionTarget"][0] }}
        </span>
      </b-form-group>

      <!-- AccessFuelStock -->
      <b-form-group
        label-for="AccessFuelStock"
        :label="$t('profile.accessFuelStock')"
      >
        <b-form-select
          id="AccessFuelStock"
          :options="optionsBoolean"
          v-model="model.accessFuelStock"
        />
        <span class="text-danger" v-if="modelstate['AccessFuelStock']">
          {{ modelstate["AccessFuelStock"][0] }}
        </span>
      </b-form-group>

      <!-- AccessGasStation -->
      <b-form-group
        label-for="AccessGasStation"
        :label="$t('profile.accessGasStation')"
      >
        <b-form-select
          id="AccessGasStation"
          :options="optionsBoolean"
          v-model="model.accessGasStation"
        />
        <span class="text-danger" v-if="modelstate['AccessGasStation']">
          {{ modelstate["AccessGasStation"][0] }}
        </span>
      </b-form-group>
    </div>

    <div v-if="$store.getters.hasAccessRevision" class="mt-4">
      <h3>{{ $t("profile.accessRevisionPermissions") }}</h3>

      <!-- AccessRevision -->
      <b-form-group
        label-for="AccessRevision"
        :label="$t('profile.accessRevision')"
      >
        <b-form-select
          id="AccessRevision"
          :options="optionsBoolean"
          v-model="model.accessRevision"
        />
        <span class="text-danger" v-if="modelstate['AccessRevision']">
          {{ modelstate["AccessRevision"][0] }}
        </span>
      </b-form-group>

      <!-- AccessRevisionJustOwn -->
      <b-form-group
        label-for="AccessRevisionJustOwn"
        :label="$t('profile.accessRevisionJustOwn')"
      >
        <b-form-select
          id="AccessRevisionJustOwn"
          :options="optionsBoolean"
          v-model="model.accessRevisionJustOwn"
        />
        <span class="text-danger" v-if="modelstate['AccessRevisionJustOwn']">
          {{ modelstate["AccessRevisionJustOwn"][0] }}
        </span>
      </b-form-group>

      <!-- AccessRevisionIndex -->
      <b-form-group
        label-for="AccessRevisionIndex"
        :label="$t('profile.accessRevisionIndex')"
      >
        <b-form-select
          id="AccessRevisionIndex"
          :options="optionsBoolean"
          v-model="model.accessRevisionIndex"
        />
        <span class="text-danger" v-if="modelstate['AccessRevisionIndex']">
          {{ modelstate["AccessRevisionIndex"][0] }}
        </span>
      </b-form-group>

      <!-- AccessRevisionDashboard -->
      <b-form-group
        label-for="AccessRevisionDashboard"
        :label="$t('profile.accessRevisionDashboard')"
      >
        <b-form-select
          id="AccessRevisionDashboard"
          :options="optionsBoolean"
          v-model="model.accessRevisionDashboard"
        />
        <span class="text-danger" v-if="modelstate['AccessRevisionDashboard']">
          {{ modelstate["AccessRevisionDashboard"][0] }}
        </span>
      </b-form-group>

      <!-- AccessRevisionModelCrud -->
      <b-form-group
        label-for="AccessRevisionModelCrud"
        :label="$t('profile.accessRevisionModelCrud')"
      >
        <b-form-select
          id="AccessRevisionModelCrud"
          :options="optionsBoolean"
          v-model="model.accessRevisionModelCrud"
        />
        <span class="text-danger" v-if="modelstate['AccessRevisionModelCrud']">
          {{ modelstate["AccessRevisionModelCrud"][0] }}
        </span>
      </b-form-group>
    </div>

    <div v-if="hasReleaseTracking" class="mt-4">
      <!-- <div>{{hasReleaseTracking}}</div> -->
      <h3>Liberações Tracking</h3>

      <!-- TrackingDeliveryman -->
      <b-form-group
        label-for="TrackingDeliveryman"
        :label="$t('profile.trackingDeliveryman')"
      >
        <b-form-select
          id="TrackingDeliveryman"
          :options="optionsBoolean"
          v-model="model.trackingDeliveryman"
        />
        <span class="text-danger" v-if="modelstate['TrackingDeliveryman']">
          {{ modelstate["TrackingDeliveryman"][0] }}
        </span>
      </b-form-group>

      <!-- TrackingPlataformAccess -->
      <b-form-group
        label-for="TrackingPlataformAccess"
        :label="$t('profile.trackingPlataformAccess')"
      >
        <b-form-select
          id="TrackingPlataformAccess"
          :options="optionsBoolean"
          v-model="model.trackingPlataformAccess"
        />
        <span class="text-danger" v-if="modelstate['TrackingPlataformAccess']">
          {{ modelstate["TrackingPlataformAccess"][0] }}
        </span>
      </b-form-group>

      <!-- CargoKanbamAvaliable -->
      <b-form-group
        label-for="CargoKanbamAvaliable"
        :label="$t('profile.cargoKanbamAvaliable')"
      >
        <b-form-select
          id="CargoKanbamAvaliable"
          :options="optionsBoolean"
          v-model="model.cargoKanbamAvaliable"
        />
        <span class="text-danger" v-if="modelstate['CargoKanbamAvaliable']">
          {{ modelstate["CargoKanbamAvaliable"][0] }}
        </span>
      </b-form-group>

      <!-- cargoExpensesAvaliable -->
      <b-form-group
        label-for="cargoExpensesAvaliable"
        :label="$t('profile.cargoExpensesAvaliable')"
      >
        <b-form-select
          id="cargoExpensesAvaliable"
          :options="optionsBoolean"
          v-model="model.cargoExpensesAvaliable"
        />
        <span class="text-danger" v-if="modelstate['CargoExpensesAvaliable']">
          {{ modelstate["CargoExpensesAvaliable"][0] }}
        </span>
      </b-form-group>

      <!-- AccessTypeOccurrence -->
      <b-form-group
        label-for="AccessTypeOccurrence"
        :label="$t('profile.accessTypeOccurrence')"
      >
        <b-form-select
          id="accessTypeOccurrence"
          :options="optionsBoolean"
          v-model="model.accessTypeOccurrence"
        />
        <span class="text-danger" v-if="modelstate['AccessTypeOccurrence']">
          {{ modelstate["AccessTypeOccurrence"][0] }}
        </span>
      </b-form-group>

      <!-- AccessTypeOccurrenceExpense -->
      <b-form-group
        label-for="AccessTypeOccurrenceExpense"
        :label="$t('profile.accessTypeOccurrenceExpense')"
      >
        <b-form-select
          id="accessTypeOccurrenceExpense"
          :options="optionsBoolean"
          v-model="model.accessTypeOccurrenceExpense"
        />
        <span
          class="text-danger"
          v-if="modelstate['AccessTypeOccurrenceExpense']"
        >
          {{ modelstate["AccessTypeOccurrenceExpense"][0] }}
        </span>
      </b-form-group>

      <!-- AccessTypeVehicle -->
      <b-form-group
        label-for="AccessTypeVehicle"
        :label="$t('profile.accessTypeVehicle')"
      >
        <b-form-select
          id="accessTypeVehicle"
          :options="optionsBoolean"
          v-model="model.accessTypeVehicle"
        />
        <span class="text-danger" v-if="modelstate['AccessTypeVehicle']">
          {{ modelstate["AccessTypeVehicle"][0] }}
        </span>
      </b-form-group>

      <!-- AccessLoads -->
      <b-form-group label-for="AccessLoads" :label="$t('profile.accessLoads')">
        <b-form-select
          id="accessLoads"
          :options="optionsBoolean"
          v-model="model.accessLoads"
        />
        <span class="text-danger" v-if="modelstate['AccessLoads']">
          {{ modelstate["AccessLoads"][0] }}
        </span>
      </b-form-group>

      <!-- CanActivateLoads -->
      <b-form-group
        label-for="CanActivateLoads"
        :label="$t('profile.canActivateLoads')"
      >
        <b-form-select
          id="canActivateLoads"
          :options="optionsBoolean"
          v-model="model.canActivateLoads"
        />
        <span class="text-danger" v-if="modelstate['CanActivateLoads']">
          {{ modelstate["CanActivateLoads"][0] }}
        </span>
      </b-form-group>

      <!-- CanDeleteLoads -->
      <b-form-group
        label-for="CanDeleteLoads"
        :label="$t('profile.canDeleteLoads')"
      >
        <b-form-select
          id="canDeleteLoads"
          :options="optionsBoolean"
          v-model="model.canDeleteLoads"
        />
        <span class="text-danger" v-if="modelstate['CanDeleteLoads']">
          {{ modelstate["CanDeleteLoads"][0] }}
        </span>
      </b-form-group>
    </div>

    <div v-if="hasReleaseBI" class="mt-4">
      <h3>Liberações BI</h3>

      <!-- BI -->
      <b-form-group label-for="BI" :label="$t('geral.bi')">
        <b-form-select id="BI" :options="optionsBoolean" v-model="model.bi" />
        <span class="text-danger" v-if="modelstate['BI']">
          {{ modelstate["BI"][0] }}
        </span>
      </b-form-group>
      <profile-power-bi-views
        class="mt-4"
        :model="model"
        :modelstate="modelstate"
      >
      </profile-power-bi-views>
    </div>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "ProfileCrudData",
  components: {
    ProfilePowerBiViews: () =>
      import("@/components_rms/System/Profile/ProfilePowerBiViews.vue")
  },
  props: {
    model: Object,
    modelstate: Array
  },
  data() {
    return {
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" }
      ],
      userReleases: {
        bi: false
      }
    };
  },
  created() {
    this.$apiScheduler.get("/profileUser/getCompanyReleases").then(response => {
      this.userReleases = response.data;
    });
  },
  computed: {
    hasReleaseBI() {
      if (this.userReleases) {
        return this.userReleases.bi;
      }
      return false;
    },
    hasReleaseChecklist() {
      if (this.$store.state.checklist) {
        return this.$store.state.checklist;
      }
      return false;
    },
    hasReleaseTracking() {
      if (this.$store.state.tracking) {
        return this.$store.state.tracking;
      }
      return false;
    }
  },
  methods: {}
};
</script>
